import React, { FC } from 'react';
import * as dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { isMobile } from 'react-device-detect';
import * as translations from '../../strings';
import { getLangKey } from '../../../../../../../javascript/models/Language';
import styles from '../index.module.css';

const strings = translations[getLangKey()];

type Props = {
  container: Element;
  dueAt: string | null;
  onDueDateChange: (dueAt: string | null) => void;
  inputSize: 'large' | 'middle';
};

const DueDate: FC<Props> = ({
  container,
  dueAt,
  onDueDateChange,
  inputSize
}) => {
  const handleOnChange = (date: dayjs.Dayjs | null) => {
    onDueDateChange(date ? date.startOf('day').toISOString() : null);
  };

  return (
    // @ts-ignore
    <DatePicker
      allowClear
      inputReadOnly={isMobile}
      value={dueAt ? dayjs(dueAt) : null}
      format="D MMM YYYY"
      placeholder={strings.dueDate}
      onChange={handleOnChange}
      getPopupContainer={() => container as HTMLElement}
      size={inputSize}
      className={styles.datePicker}
      popupClassName={styles.datePickerDropdown}
      data-cy="create-task-due-date"
    />
  );
};

export default DueDate;
